import { create } from 'zustand';

export type SearchTab = 'Trek' | 'Stay' | 'Boat' | 'Ski' | 'Ride' | 'Guide';

type SearchState = {
  tab: SearchTab;
  where: string;
  startDay: number;
  endDay: number;
  guests: number;
  setTab: (tab: SearchTab) => void;
  setWhere: (where: string) => void;
  setDates: (start: number, end: number) => void;
  setGuests: (guests: number) => void;
};

export const useSearchStore = create<SearchState>((set) => ({
  tab: 'Trek',
  where: 'Pahalgam, Kashmir',
  startDay: 18,
  endDay: 25,
  guests: 2,
  setTab: (tab) => set({ tab }),
  setWhere: (where) => set({ where }),
  setDates: (startDay, endDay) => set({ startDay, endDay }),
  setGuests: (guests) => set({ guests: Math.max(1, Math.min(16, guests)) }),
}));
